import { Component, OnInit, Input, ViewEncapsulation, ViewChild, ChangeDetectorRef } from "@angular/core";
import { SharedService } from '../shared';
import { TherapieTabsEnum, D_THCKonzentrationStartInput, D_KolbenpipetteValue, D_DosierpumpeValue } from './titration-rechner.model';

import { TitrationTherapieStartenComponent } from './therapie-starten';
import { TitrationTherapieFortsetzenComponent } from './therapie-fortsetzen';
import { PartnerNamesEnum } from '../medizinisches-cannabisantrag/shared';

@Component({
    selector: 'app-titration-rechner',
    templateUrl: "./titration-rechner.component.html",
    styleUrls: ["./titration-rechner.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class TitrationRechnerComponent implements OnInit {
    @Input() partnerName: string = "";
    partnerObj: any = null;
    PartnerNamesEnum = PartnerNamesEnum;

    @ViewChild(TitrationTherapieStartenComponent) therapieStartenComponent: TitrationTherapieStartenComponent;
    @ViewChild(TitrationTherapieFortsetzenComponent) therapieFortsetzenComponent: TitrationTherapieFortsetzenComponent;

    showLoading: boolean = false;

    TherapieTabsEnum = TherapieTabsEnum;
    ActiveTherapieTab: TherapieTabsEnum = null;

    KolbenpipetteValue = D_KolbenpipetteValue;
    DosierpumpeValue = D_DosierpumpeValue;

    D_thcKonzentrationList: any[] = [];
    D_artDerDorierungList: any[] = [];
    D_verschreibungsmengeList: any[] = [];

    thcKonzentrationList: any[] = [];
    artDerDorierungList: any[] = [];
    verschreibungsmengeList: any[] = [];

    thcKonzentrationInput: string = D_THCKonzentrationStartInput;

    productExpanded: boolean = false;
    productList: any[] = [];
    productNameInput: any = null;

    constructor(private sharedService: SharedService,
        private cd: ChangeDetectorRef) {

    }

    fnSetDefaultValues() {
        this.KolbenpipetteValue = D_KolbenpipetteValue;
        this.DosierpumpeValue = D_DosierpumpeValue;

        this.D_thcKonzentrationList = [
            { ProductName: 'Dronabinol 10 mg/mL', THC: 10, CBD: 0, ART: 'Dronabinol' },
            { ProductName: 'Dronabinol 25 mg/mL', THC: 25, CBD: 0, ART: 'Dronabinol' },
            { ProductName: 'Dronabinol 50 mg/mL', THC: 50, CBD: 0, ART: 'Dronabinol' },
            { ProductName: 'Extrakt THC 5 mg/mL', THC: 5, CBD: 0, ART: 'Cannabisextrakt' },
            { ProductName: 'Extrakt THC 10 mg/mL', THC: 10, CBD: 0, ART: 'Cannabisextrakt' },
            { ProductName: 'Extrakt THC 12,5 mg/mL', THC: 12.5, CBD: 0, ART: 'Cannabisextrakt' },
            { ProductName: 'Extrakt THC 20 mg/mL', THC: 20, CBD: 0, ART: 'Cannabisextrakt' },
            { ProductName: 'Extrakt THC 25 mg/mL', THC: 25, CBD: 0, ART: 'Cannabisextrakt' },
            { ProductName: 'Extrakt THC 30 mg/mL', THC: 30, CBD: 0, ART: 'Cannabisextrakt' },
            { ProductName: 'Extrakt THC 50 mg/mL', THC: 50, CBD: 0, ART: 'Cannabisextrakt' }
        ];
        this.D_artDerDorierungList = [
            { text: 'Kolbenpipette (mL)', value: this.KolbenpipetteValue },
            { text: 'Dosierpumpe (Hübe)', value: this.DosierpumpeValue }
        ];
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
                this.D_verschreibungsmengeList = [
                    { text: '25 mL', value: 25 },
                    { text: '50 mL', value: 50 },
                    { text: '75 mL', value: 75 },
                    { text: '100 mL', value: 100 },
                    { text: '125 mL', value: 125 }
                ];
                break;
            default:
                this.D_verschreibungsmengeList = [
                    { text: '5 mL', value: 5 },
                    { text: '10 mL', value: 10 },
                    { text: '15 mL', value: 15 },
                    { text: '20 mL', value: 20 },
                    { text: '25 mL', value: 25 },
                    { text: '30 mL', value: 30 },
                    { text: '40 mL', value: 40 },
                    { text: '50 mL', value: 50 }
                ];
                break;
        }
    }

    ngOnInit(): void {
        this.fnSetDefaultValues();

        const queries = this.sharedService.getUrlVars();
        const dc = queries["dc"];
        const dc_timestamp = queries["dc_timestamp"];
        if (dc && dc_timestamp) {
            this.setTitrationDataList();
        } else {
            this.redirectToLoginPage();
        }
    }

    redirectToLoginPage() {
        var redirectUrl = `${window.location.origin}`;
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_DEMO:
                redirectUrl = `${redirectUrl}/dosis-eq/demo/doc`;
                break;
            default:
                redirectUrl = `${redirectUrl}/titration/doc`;
                break;
        }
        //window.open(redirectUrl, "_self");
    }

    fnCheckPartnerDetail() {
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_DEMO:
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
            case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                this.getPartnerConfig();
                break;
            default:
                this.ActiveTherapieTab = TherapieTabsEnum.STARTEN;
                break;
        }
    }

    getPartnerConfig() {
        this.sharedService.getPartnerConfig().subscribe(res => {
            if (res) {
                let partnerObj = res[this.partnerName];
                if (partnerObj) {
                    this.partnerObj = partnerObj;
                    this.getProductList();
                } else {
                    this.redirectToLoginPage();
                }
            } else {
                this.redirectToLoginPage();
            }
        }, err => {
            this.redirectToLoginPage();
        })
    }

    setTitrationDataList() {
        this.thcKonzentrationList = [...this.D_thcKonzentrationList];
        this.artDerDorierungList = [...this.D_artDerDorierungList];
        this.verschreibungsmengeList = [...this.D_verschreibungsmengeList];

        this.fnCheckPartnerDetail();
    }

    onTabChange(tab: TherapieTabsEnum) {
        if (tab != this.ActiveTherapieTab) {
            if (this.productList.length) {
                let product = this.productList.find(a => a.ProductName == this.productNameInput);
                if (product) {
                    this.fnSelectProduct(product.ProductName);
                } else {
                    this.fnSelectProduct(this.productList[0].ProductName);
                }
            }
            this.ActiveTherapieTab = tab;
        }
    }


    onIconClick(type: any) {
        if (this.ActiveTherapieTab == TherapieTabsEnum.STARTEN) {
            this.therapieStartenComponent.onIconClick(type);
        } else {
            this.therapieFortsetzenComponent.onIconClick(type);
        }
    }

    onChooseProductName(productName) {
        this.fnSelectProduct(productName);
    }

    getProductList() {
        var Ids = this.partnerObj["ProductIds"];
        let payload = {
            ProductIds: Ids,
            ClientName: this.partnerName
        }
        this.sharedService.getProductList(payload).subscribe(res => {
            if (res) {
                this.fnSetProductList(res);
            } else {
                this.fnSetProductList();
            }
        }, err => {
            this.fnSetProductList();
        })
    }

    fnSetProductList(res = []) {
        this.productList = res;
        if (this.productList.length) {
            this.fnSelectProduct(this.productList[0].ProductName);
        }
        this.ActiveTherapieTab = TherapieTabsEnum.STARTEN;
    }

    fnSelectProduct(productName) {
        this.fnChooseProduct(productName);
        this.productNameInput = productName;
        this.cd.detectChanges();
    }

    fnChooseProduct(productName) {
        let product = this.productList.find(a => a.ProductName == productName) || {};

        let _THCKonzentration = product["THCKonzentration"];
        if (_THCKonzentration && _THCKonzentration.indexOf("Extrakt") >= 0 && _THCKonzentration.indexOf("THC") < 0) {
            _THCKonzentration = _THCKonzentration.replace("Extrakt", "Extrakt THC");
        }
        this.thcKonzentrationInput = _THCKonzentration || D_THCKonzentrationStartInput;
        let Dosierungsart: any[] = product["Dosierungsart"] || [];
        let Verschreibungsmenge: any[] = product["Verschreibungsmenge"] || [];

        if (Dosierungsart.length) {
            this.artDerDorierungList = [];
            for (var i = 0; i < this.D_artDerDorierungList.length; i++) {
                let obj = this.D_artDerDorierungList[i];
                if (Dosierungsart.indexOf(`${obj.value}`) > -1 || Dosierungsart.indexOf(obj.value) > -1) {
                    this.artDerDorierungList.push(obj);
                }
            }
        }

        if (Verschreibungsmenge.length) {
            this.verschreibungsmengeList = [];
            for (var i = 0; i < this.D_verschreibungsmengeList.length; i++) {
                let obj = this.D_verschreibungsmengeList[i];
                if (Verschreibungsmenge.indexOf(`${obj.value}`) > -1 || Verschreibungsmenge.indexOf(obj.value) > -1) {
                    this.verschreibungsmengeList.push(obj);
                }
            }
        }

    }
}
